export default "__VITE_ASSET__DMD2mxCH__"